/**
 * Legend width computation for DataLegend (data plugin).
 *
 * ## Layout
 *
 *   ┌───────────────────────────────────────┬──────────┐
 *   │ #legend (DefaultRow, flex:1)          │ #toggle  │
 *   │  [icon] [label-container] [badge]     │ eye icon │
 *   │                                       │ pad:4 6  │
 *   └───────────────────────────────────────┴──────────┘
 *   :host { display: flex }
 *
 * ## Constants (from sentinel bounding boxes)
 *
 *   DefaultRow width  = DefaultLegendLayout.width(label)  (includes badge+pad)
 *   toggle icon       = 16px  (LonaIcons.make sizePx:16)
 *   toggle padL       =  6px
 *   toggle padR       =  6px
 *                     ──────
 *   TOGGLE_WIDTH      = 28px
 *
 * ## Verified from
 *
 *   sentinel label="garmin-stress" (default-row/layout inside DataLegend):
 *     DefaultRow host=145  labelEl=76  badgeW=20
 *     host = 24 + 1 + 8 + 76 + 8 + 8 + 20 = 145 ✓
 *
 *   DataLegend Nested (sentinel) = 173 = 145 + 28(toggle)
 *   Sentinel body = 173 + 8 (SheetLegend pad) = 181
 *   Formula: DefaultLegendLayout.width("garmin-stress") + 28
 *          = (ceil(76) + 77) + 28 = 153 + 28 = 181 ✓
 */

import { DefaultLegendLayout, type TextMeasurer } from "@tento-lona/sheets-ui/sheet/default-legend-layout.ts";

const TOGGLE_WIDTH = 28;

function dataLegendWidth(
  label: string,
  measure: TextMeasurer,
): number {
  return DefaultLegendLayout.width({ label, timescaleVisible: false }, measure) + TOGGLE_WIDTH;
}

export namespace DataLegendLayout {
  export const width = dataLegendWidth;
}
